import { useCallback } from 'react';

import { BoxIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

import IfIcon from '@/components/atoms/Icons/IfIcon';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { popModal } from '@/redux/modals/actions';
import { selectAccountSlug } from '@/redux/session/selectors';
import { Rule } from '@/shared/types/rules';

type Props = { rule: Rule & { desk_name: string } };

export const RuleLink = ({ rule }: Props) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);
  const link = `/${slug}/environments/${rule?.desk_id}/rules/${rule?.rule_id}`;
  const dispatch = useDispatch();

  const isRuleInactive = rule.status === 'inactive';

  const handleOnClick = useCallback(() => {
    dispatch(popModal());
  }, [dispatch]);

  return (
    <div
      className={cn('flex w-full max-w-[420px] items-center gap-1 truncate text-muted-foreground', {
        'max-w-[380px]': isRuleInactive,
      })}
    >
      <BoxIcon size={16} className="inline-block align-baseline text-muted-foreground" />
      {rule?.desk_name} /
      <IfIcon className="text-muted-foreground" />
      <Link to={link} onClick={handleOnClick} className="text-primary">
        {rule?.name}
      </Link>
      {isRuleInactive && (
        <Badge flavour={'neutral'} type="secondary">
          {t('rules.inactive')}
        </Badge>
      )}
    </div>
  );
};
